import { CreditCard } from './credit-card';
import { Discount } from './discount';

export class CreditCardData extends CreditCard {
  totalValue: number;
  invoiceDate: string;
  chargedUser: boolean;
  discountedValue: number;
  invoiceId: string;
  status: string;
  hideExpirationDate: boolean;
  appliedCoupons: Array<Discount>;
  planName: string;

  constructor(data?: any) {
    super(data)
    if (!data) return;

    this.status = data.status;
    this.invoiceId = data.invoiceId;
    this.hideExpirationDate = data.hideExpirationDate;
    this.totalValue = data.totalValue;
    this.discountedValue = data.discountedValue;
    this.invoiceDate = data.invoiceDate;
    this.chargedUser = data.chargedUser;
    this.planName = data.planName;

    if (data.appliedCoupons && data.appliedCoupons.length) {
      this.appliedCoupons = data.appliedCoupons.map(coupon => new Discount(coupon));
    }
  }
}
